export const GiftingIneligibleContent = {
  giftingIneligibleDesc: {
    giftingIneligibleDescList: [
      'You may be trying to gift from an ineligible account type, such as a Vanguard Cash Plus Account, or your account may not have a balance from which to gift.',
      'If this is a managed account, please consult your advisor to	gift on your behalf.',
    ],
  },
  contactUs: {
    contactusHeading: 'Your account is not eligible for this gift process',
    contactusDesc:
      'We apologize for the inconvenience. There are several reasons why you may be receiving this message. Please review the following information:',
  },
  buttonLabel: 'View my accounts',
};
